// Key Features Images
import MyCustomers from "../../../assets/images/features/my-customers.png";
import Jobbing from "../../../assets/images/features/jobbing.png";
import Invoicing from "../../../assets/images/features/invoice.png";
import InventoryManagement from "../../../assets/images/features/inventory-management.png";
import MyAssets from "../../../assets/images/features/my-assets.png";
import HoseTags from "../../../assets/images/features/hose-tags.png";
import Quoting from "../../../assets/images/features/quoting.png";
import Reporting from "../../../assets/images/features/reporting.png";
import DigitalTwin from "../../../assets/images/features/digital-twin.png";
import OfflineMode from "../../../assets/images/features/offline.png";
import NonBOAItems from "../../../assets/images/features/non-boa-items.png";
import MyOrders from "../../../assets/images/features/my-orders.png";

// Customer Feedback
import boahubUser1 from "../../../assets/images/login/boahubUsers/boahub-user1.png";

export const keyFeatures = [
  {
    imageUrl: MyCustomers,
    width: 450,
    height: 300,
    title: "Customer Management",
    description:
      "Effective customer management involves uploading customer information, utilizing it in job cards, setting sell pricing, labour, travel, and crimp rates, and customizing customer-specific discounts.",
  },
  {
    imageUrl: Jobbing,
    width: 470,
    height: 275,
    title: "Job Card Management",
    description:
      "Order, receipt, track and sell inventory all from within BOAhub. The system records audit trails, allows bulk uploads of customers, and more. Learn more about the Job Card Management.",
  },
  {
    imageUrl: Invoicing,
    width: 450,
    height: 300,
    title: "Invoicing",
    description:
      "Cut admin tasks with BOAhub Xero Integration. Seamless integration with Xero for a end-to-end business solution. Learn more about our invoicing.",
  },
  {
    imageUrl: InventoryManagement,
    width: 330,
    height: 300,
    title: "Inventory Management",
    description:
      "Simplify tracking multiple stock locations, ensuring the right products are available when needed, & maintaining accurate order histories. Learn more about how the inventory management works in the BOAhub.",
  },
  {
    imageUrl: MyAssets,
    width: 450,
    height: 300,
    title: "Asset Management",
    description:
      "With the My Assets feature, you can record faults on the machine and push them to the mechanic in a few clicks. Learn more about how to manage your assets using the BOAhub.",
  },
  {
    imageUrl: HoseTags,
    width: 450,
    height: 300,
    title: "Hose Tag System",
    description:
      "Tag and track your hose lines through a smart tag system. With just a simple tag, track the entire history of your hose assembly - from components to manufacturer, dates, and assets. Learn more about hose tagging.",
  },
  {
    imageUrl: Quoting,
    width: 450,
    height: 300,
    title: "Quoting",
    description:
      "Easily create and manage a quote for your customer within the BOAhub in just minutes. Effortlessly access pricing, parts, & customer details. Simplify your workflow with the BOAhub.",
  },
  {
    imageUrl: Reporting,
    width: 450,
    height: 300,
    title: "Reporting",
    description:
      "Smarter reporting, stronger business. BOAhub delivers the data you need—when you need it. From job history to cost analysis, get clear reports that help you stay ahead. Learn more about Reporting.",
  },
  {
    imageUrl: DigitalTwin,
    width: 445,
    height: 250,
    title: "Digital Twin",
    description:
      "The BOAhub's Asset Hydraulic Hose Map assigns BOMs to specific areas within your equipment, giving you a complete breakdown of every hose assembly for easier maintenance and faster repairs. Learn more about Asset Hydraulic Hose Map.",
  },
  {
    imageUrl: OfflineMode,
    width: 445,
    height: 250,
    title: "Offline Mode",
    description:
      "Keep track of your stocks even if you are out of service. Create and manage job cards, create hose assemblies, assign hoses to assets, and add stock to cart while offline.",
  },
  {
    imageUrl: NonBOAItems,
    width: 450,
    height: 300,
    title: "Non-BOA Items",
    description:
      "Create, name, and save parts or items not sourced through BOA, directly within the BOAhub. This allows you to maintain accurate records of every part used: BOA or otherwise, ensuring full job transparency and traceability.",
  },
  {
    imageUrl: MyOrders,
    width: 450,
    height: 300,
    title: "My Orders",
    description:
      "Take control with ‘My Orders’ – real-time updates, full visibility, and streamlined tools to manage every order with confidence and efficiency.",
  },
];

export const boahubUsersData = [
  {
    thumbnailUrl: "https://img.youtube.com/vi/g2ZBlBNCQDA/maxresdefault.jpg",
    videoUrl: "https://youtu.be/g2ZBlBNCQDA",
    customerName: "Cody from Leeuwin Civil",
    comment: `"They (BOA) put a barcode on the hoses and can be logged to a machine (via the BOAhub) so you know when it was fitted, whose fitted it, and all the other information. It's all documented there. So I think that's another good thing is what service life you're getting out of that hose as well."`,
  },
  {
    thumbnailUrl: "https://img.youtube.com/vi/OAU0BwWuLyo/maxresdefault.jpg",
    videoUrl: "https://youtu.be/OAU0BwWuLyo",
    customerName: "Troy from NCJ Adamson",
    comment: `"No more paper trail. The operators get on the app every morning to do a pre-start. We're able to prioritize the jobs for the day or the week. Then once we've completed a task on the app and completed the jobs, our office goes through it, and send invoices from the app to them. Taking the paper base trail away. Watch the full review."`,
  },
  {
    thumbnailUrl: "https://img.youtube.com/vi/9pOY3JXk1LQ/maxresdefault.jpg",
    videoUrl: "https://youtu.be/9pOY3JXk1LQ",
    customerName: "Nelson & Sons Engineering",
    comment: `"I know everything that is inside my BOApod trailer just by going onto my app. I know what has been used, what I have on hand, and what I need to order, with a click of a button. And with everything being barcoded in the trailer, it makes it easy for reordering - just scan and go."`,
  },
];
